import DOMPurify from "isomorphic-dompurify";
import { ClassNameValue } from "tailwind-merge";

const SafeHtmlRenderer = ({
  html,
  className,
}: {
  html: string;
  className?: ClassNameValue;
}) => {
  const sanitizedHtml = DOMPurify.sanitize(html);

  return (
    <div
      dangerouslySetInnerHTML={{ __html: sanitizedHtml }}
      {...(className ? { className: className as string } : {})}
    />
  );
};

export default SafeHtmlRenderer;
